import context from '../../config/context'
import React from 'react'
import { Link } from '@cobalt/cobalt-react-components'
import {
  DIFFERENT_PASSWORDS_ERROR_MESSAGE,
  GENERIC_PASSWORD_CHANGE_ERROR,
  INVALID_RESET_TOKEN_ERROR_PART_1,
  INVALID_RESET_TOKEN_ERROR_PART_2,
  LOW_QUALITY_PASSWORD_ERROR_PART_1,
  NEED_HELP,
  CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE
} from '../../constants/ui.labels'
import {
  DIFFERENT_PASSWORDS_CODE,
  GENERIC_PASSWORD_CHANGE_CODE,
  INVALID_RESET_TOKEN_CODE,
  LOW_QUALITY_PASSWORD_CODE,
  CURRENT_PASSWORD_DOESNT_MATCH_CODE,
  PASSWORD_NOT_COMPLIANT_CODE
} from '../../constants/error.codes'
import { PASSWORD_RESET, CHANGE_PASSWORD_HELP } from '../../constants/links'
import PasswordPolicies from '../../components/PasswordPolicies'

const lowQualityPassword = () => (
  <React.Fragment>
    {LOW_QUALITY_PASSWORD_ERROR_PART_1}{' '}
    <Link target="_blank" href={CHANGE_PASSWORD_HELP}>
      {NEED_HELP}
    </Link>
  </React.Fragment>
)

const notCompliantPassword = () => (
  <React.Fragment>
    <PasswordPolicies
      isError={true}
      passwordPolicies={context.passwordPolicies}
    />
  </React.Fragment>
)

export default (code, genericMessage) => {
  return (
    {
      [CURRENT_PASSWORD_DOESNT_MATCH_CODE]: CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE,
      [DIFFERENT_PASSWORDS_CODE]: DIFFERENT_PASSWORDS_ERROR_MESSAGE,
      [GENERIC_PASSWORD_CHANGE_CODE]: GENERIC_PASSWORD_CHANGE_ERROR,
      [INVALID_RESET_TOKEN_CODE]: (
        <React.Fragment>
          {INVALID_RESET_TOKEN_ERROR_PART_1}
          <Link href={PASSWORD_RESET}>{INVALID_RESET_TOKEN_ERROR_PART_2}</Link>
        </React.Fragment>
      ),
      [LOW_QUALITY_PASSWORD_CODE]: lowQualityPassword(),
      [PASSWORD_NOT_COMPLIANT_CODE]: notCompliantPassword()
    }[code] || genericMessage
  )
}
